import type { IEmailRecipientFilterGroup } from "../../interfaces/models/IEmailDistributionList";

export function buildPersonIdInFilter(
  personIds: string[],
): IEmailRecipientFilterGroup | null {
  const ids = [...new Set(personIds.map((id) => id.trim()).filter(Boolean))];
  if (!ids.length) {
    return null;
  }
  return {
    logic: "AND",
    conditions: [{ field: "id", comparison: "IN", value: ids }],
  };
}

function groupHasContent(g: IEmailRecipientFilterGroup | null | undefined): boolean {
  if (!g) {
    return false;
  }
  return (
    (g.conditions?.length ?? 0) > 0 || (g.groups?.length ?? 0) > 0
  );
}

/** Union of two independent recipient sources (distribution list vs Test List). */
export function mergeRecipientFiltersOr(
  a: IEmailRecipientFilterGroup | null | undefined,
  b: IEmailRecipientFilterGroup | null | undefined,
): IEmailRecipientFilterGroup | null {
  const hasA = groupHasContent(a);
  const hasB = groupHasContent(b);
  if (!hasA && !hasB) {
    return null;
  }
  if (hasA && !hasB) {
    return a!;
  }
  if (!hasA && hasB) {
    return b!;
  }
  return { logic: "OR", groups: [a!, b!] };
}
